import { T } from '@colonist/ui';
import { UIGameButton } from '../../../../common/UIGameButton/index.ts';
import styles from './PlacementChange.module.scss';
import rankedStyles from '../UIGameEndRankedScreen.module.scss';
import React from 'react';
export function PlacementChange({ rankedState, onContinue }) {
    const { title, description } = rankedState.getEndGameScreenText();
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.contentContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement(T, {
        id: description
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.buttonContainer
    }, /*#__PURE__*/ React.createElement(UIGameButton, {
        className: rankedStyles.continueButton,
        onClick: onContinue
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.footer.continue'
        }
    }))));
}
